export const tooltipText = {
  average_learner_rating: 'Average student rating of this quest (1-5)',
  average_learner_effort: 'Average student effort rating of this quest (1-3)',
  percent_quests_recommended: '% of students that recommend this quest',
  quests_in_progress_by_learners_count:
    'Students working on this quest right now',
  quests_completed_by_learners_count: 'This quest completed by students'
}



// WEBPACK FOOTER //
// ./src/utils/studentstats.js